'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _insertPlayable = require('./players/insertPlayable');

var _insertPlayable2 = _interopRequireDefault(_insertPlayable);

var _play = require('./players/play');

var _play2 = _interopRequireDefault(_play);

var _pause = require('./players/pause');

var _pause2 = _interopRequireDefault(_pause);

var _setAutoAdvance = require('./players/setAutoAdvance');

var _setAutoAdvance2 = _interopRequireDefault(_setAutoAdvance);

var _setAutoPlay = require('./players/setAutoPlay');

var _setAutoPlay2 = _interopRequireDefault(_setAutoPlay);

var _setStream = require('./players/setStream');

var _setStream2 = _interopRequireDefault(_setStream);

var _setCanPlay = require('./players/setCanPlay');

var _setCanPlay2 = _interopRequireDefault(_setCanPlay);

var _setCurrentTimeMs = require('./players/setCurrentTimeMs');

var _setCurrentTimeMs2 = _interopRequireDefault(_setCurrentTimeMs);

var _setFocus = require('./players/setFocus');

var _setFocus2 = _interopRequireDefault(_setFocus);

var _setLooping = require('./players/setLooping');

var _setLooping2 = _interopRequireDefault(_setLooping);

var _setMute = require('./players/setMute');

var _setMute2 = _interopRequireDefault(_setMute);

var _setPlayingIndex = require('./players/setPlayingIndex');

var _setPlayingIndex2 = _interopRequireDefault(_setPlayingIndex);

var _setPlaybackRate = require('./players/setPlaybackRate');

var _setPlaybackRate2 = _interopRequireDefault(_setPlaybackRate);

var _setPlayables = require('./players/setPlayables');

var _setPlayables2 = _interopRequireDefault(_setPlayables);

var _setQuality = require('./players/setQuality');

var _setQuality2 = _interopRequireDefault(_setQuality);

var _setQueueEnded = require('./players/setQueueEnded');

var _setQueueEnded2 = _interopRequireDefault(_setQueueEnded);

var _setSeeking = require('./players/setSeeking');

var _setSeeking2 = _interopRequireDefault(_setSeeking);

var _setVolume = require('./players/setVolume');

var _setVolume2 = _interopRequireDefault(_setVolume);

var _removePlayable = require('./players/removePlayable');

var _removePlayable2 = _interopRequireDefault(_removePlayable);

var _reorderPlayable = require('./players/reorderPlayable');

var _reorderPlayable2 = _interopRequireDefault(_reorderPlayable);

var _toggleFullscreen = require('./players/toggleFullscreen');

var _restartPlayables = require('./players/restartPlayables');

var _restartPlayables2 = _interopRequireDefault(_restartPlayables);

var _setContextMenu = require('./players/setContextMenu');

var _setContextMenu2 = _interopRequireDefault(_setContextMenu);

var _updatePlayables = require('./players/updatePlayables');

var _updatePlayables2 = _interopRequireDefault(_updatePlayables);

var _constants = require('../actions/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  actionConstants: _constants2.default, // export action types to enable external reducers to respond to actions
  insertPlayable: _insertPlayable2.default,
  play: _play2.default,
  pause: _pause2.default,
  setAutoAdvance: _setAutoAdvance2.default,
  setAutoPlay: _setAutoPlay2.default,
  setStream: _setStream2.default,
  setCanPlay: _setCanPlay2.default,
  setCurrentTimeMs: _setCurrentTimeMs2.default,
  setFocus: _setFocus2.default,
  setLooping: _setLooping2.default,
  setMute: _setMute2.default,
  setPlayingIndex: _setPlayingIndex2.default,
  setPlaybackRate: _setPlaybackRate2.default,
  setPlayables: _setPlayables2.default,
  setQuality: _setQuality2.default,
  setQueueEnded: _setQueueEnded2.default,
  setSeeking: _setSeeking2.default,
  setVolume: _setVolume2.default,
  removePlayable: _removePlayable2.default,
  reorderPlayable: _reorderPlayable2.default,
  toggleFullscreen: _toggleFullscreen.toggleFullscreen,
  setFullscreen: _toggleFullscreen.setFullscreen,
  restartPlayables: _restartPlayables2.default,
  setContextMenu: _setContextMenu2.default,
  updatePlayables: _updatePlayables2.default
};
module.exports = exports['default'];